import React from 'react'
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import {  faRoad, faUserCheck, faWallet, faInstagram, faEdit, faTwitter } from '@fortawesome/free-solid-svg-icons'
import './index.css';
import InstagramIcon from '@material-ui/icons/Instagram';
import FacebookIcon from '@material-ui/icons/Facebook';
import TwitterIcon from '@material-ui/icons/Twitter';


const Footer = () => {
    return (
        <div>
            <footer className='footer'>
                <div className='container'>
                    <div className='social-media-links'>
                        <div className="icon1">
                            <InstagramIcon style={{ fontSize: 40 }} />
                        </div>
                        <div className="icon1">
                            <FacebookIcon style={{ fontSize: 40 }} />
                        </div>
                        <div className="icon1">
                            <TwitterIcon style={{ fontSize: 40 }} />
                        </div>
                    </div>
                    <p>Gravity Gym &copy; 2021, All Rights Reserved</p>
                </div>

            </footer>
        </div>
    )
}

export default Footer
